import React, { Component } from "react";
import PropTypes from "prop-types";
import DynamicGrid from "../DynamicGrid";
import { ElevatorDialog } from "../ElevatorDialog";

const Settings = {
	ShowDateFilter: false,
	SortColumn: "serial_number",
	UseTicketTypeFilter: false,
	ShowNewButton: true,
	NewButtonText: "Add Elevator",
};

class ElevatorListing extends Component {
	constructor(props) {
		super(props);
		this.state = {
			Elevators: [],
			ModalVisible: false,
			SelectedElevator: null,
		};
		this.getData();

		this.CloseElevator = this.CloseElevator.bind(this);
		this.AddElevator = this.AddElevator.bind(this);
		Settings.NewButtonAction = this.AddElevator;
	}

	AddElevator() {
		this.setState({ SelectedElevator: null, ModalVisible: true });
	}

	componentDidUpdate(prevProps) {
		if (this.props.BuildingID !== prevProps.BuildingID) {
			this.getData();
		}
	}

	CloseElevator() {
		this.setState({ ModalVisible: false, SelectedElevator: null });
		this.getData();
	}

	ShowElevator(item) {
		this.setState({ SelectedElevator: item.elevators_id, ModalVisible: true });
	}

	async getData() {
		if (this.props.BuildingID) {
			const data = await fetch("Building/GetElevators", {
				method: "Post",
				cache: "no-cache",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({ buildingsId: this.props.BuildingID }),
			});
			var res = await data.json();
			this.setState({ Elevators: res });
		}
	}
	render() {
		const config = [
			{ header: "Serial #", columnName: "serial_number", visible: true, typeCode: "S" },
			{ header: "Description", columnName: "description", visible: this.state.Elevators.some((item) => item.description), typeCode: "S" },
			{ header: "Days Since Last Maint.", columnName: "days_since_last_maint", visible: true, typeCode: "N" },
			{ header: "Type", columnName: "type", visible: true, typeCode: "S" },
			{ header: "Street Address", columnName: "address1", visible: true, typeCode: "S" },
			// { header: "Street Address 2", columnName: "address2", visible: true, typeCode: "S" },
			{ header: "City", columnName: "city", visible: true, typeCode: "S" },
			{ header: "State", columnName: "state", visible: true, typeCode: "S" },
			{ header: "Zip", columnName: "zip", visible: true, typeCode: "S" },
			{ header: "Track Maint.?", columnName: "track_maintenance", visible: true, typeCode: "L" },
			{ header: "Out of Service?", columnName: "out_of_service", visible: true, typeCode: "S" },
		];

		return (
			<div style={{ flex: 1, backgroundColor: "#ebebeb", overflowY: "auto", padding: "4px" }}>
				<ElevatorDialog visible={this.state.ModalVisible} ElevatorsID={this.state.SelectedElevator} BuildingsID={this.props.BuildingID} OnClose={this.CloseElevator}></ElevatorDialog>
				<DynamicGrid Title="Elevators" Configuration={config} DataSet={this.state.Elevators} Settings={Settings} OnRowClick={(row) => this.ShowElevator(row)} />
			</div>
		);
	}
}

ElevatorListing.propTypes = {
	BuildingID: PropTypes.string,
};

export default ElevatorListing;
